// // src/pages/returns/ReturnsPage.jsx
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import DashboardLayout from '../../components/layout/DashboardLayout';
// import CreateReturnModal from '../../components/returns/CreateReturnModal';
// import ReturnDetailsModal from '../../components/returns/ReturnDetailsModal';
// import { 
//   getReturnRequests, 
//   updateReturnStatus, 
//   deleteReturnRequest,
//   getReturnStatistics
// } from '../../services/returnsService';
// import { useAuth } from '../../contexts/AuthContext';
// import { useNotification } from '../../contexts/NotificationContext';

// const ReturnsPage = () => {
//   const { currentUser } = useAuth();
//   const { showAlert } = useNotification();

//   const [returns, setReturns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [stats, setStats] = useState(null);
//   const [filters, setFilters] = useState({
//     status: 'all',
//     searchTerm: '',
//     sortBy: 'createdAt',
//     sortOrder: 'desc'
//   });
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     pageSize: 25,
//     hasMore: false,
//     lastDoc: null
//   });

//   // Modal states
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [selectedReturn, setSelectedReturn] = useState(null);
//   const [actionLoading, setActionLoading] = useState('');

//   useEffect(() => {
//     loadReturns();
//     loadStats();
//   }, [filters, currentUser]);

//   const loadReturns = async (loadMore = false) => {
//     try {
//       setLoading(!loadMore);
      
//       const options = {
//         ...filters,
//         pageSize: pagination.pageSize,
//         lastDoc: loadMore ? pagination.lastDoc : null
//       };

//       const result = await getReturnRequests(options);
      
//       if (loadMore) {
//         setReturns(prev => [...prev, ...result.returns]);
//       } else {
//         setReturns(result.returns);
//       }

//       setPagination(prev => ({
//         ...prev,
//         hasMore: result.hasMore,
//         lastDoc: result.lastDoc,
//         currentPage: loadMore ? prev.currentPage + 1 : 1
//       }));
//     } catch (error) {
//       console.error('Error loading returns:', error);
//       showAlert('Failed to load return requests', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadStats = async () => {
//     try {
//       const statistics = await getReturnStatistics();
//       setStats(statistics);
//     } catch (error) {
//       console.error('Error loading return statistics:', error);
//     }
//   };

//   const handleStatusUpdate = async (returnId, newStatus, notes) => {
//     try {
//       setActionLoading(`status-${returnId}`);
//       await updateReturnStatus(returnId, newStatus, notes);
      
//       // Update local state
//       setReturns(prev => prev.map(ret => 
//         ret.id === returnId 
//           ? { ...ret, status: newStatus, statusNotes: notes }
//           : ret
//       ));

//       showAlert(`Return request ${newStatus} successfully`, 'success');
//       loadStats(); // Refresh stats
//     } catch (error) {
//       console.error('Error updating return status:', error);
//       showAlert(`Failed to ${newStatus} return request`, 'error');
//     } finally {
//       setActionLoading('');
//     }
//   };

//   const handleDeleteReturn = async (returnId) => {
//     if (!window.confirm('Are you sure you want to delete this return request?')) {
//       return;
//     }

//     try {
//       setActionLoading(`delete-${returnId}`);
//       await deleteReturnRequest(returnId);
      
//       setReturns(prev => prev.filter(ret => ret.id !== returnId));
//       showAlert('Return request deleted successfully', 'success');
//       loadStats(); // Refresh stats
//     } catch (error) {
//       console.error('Error deleting return:', error);
//       showAlert('Failed to delete return request', 'error');
//     } finally {
//       setActionLoading('');
//     }
//   };

//   const handleViewDetails = (returnRequest) => {
//     setSelectedReturn(returnRequest);
//     setShowDetailsModal(true);
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const formatDate = (date) => {
//     if (!date) return 'N/A';
//     return new Date(date).toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const getStatusBadge = (status) => {
//     const statusConfig = {
//       pending: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' },
//       approved: { bg: 'bg-green-100', text: 'text-green-800', label: 'Approved' },
//       rejected: { bg: 'bg-red-100', text: 'text-red-800', label: 'Rejected' },
//       processing: { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Processing' },
//       completed: { bg: 'bg-purple-100', text: 'text-purple-800', label: 'Completed' }
//     };

//     const config = statusConfig[status] || statusConfig.pending;

//     return (
//       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
//         {config.label}
//       </span>
//     );
//   };

//   const statsCards = [
//     {
//       title: 'Total Returns',
//       value: stats?.totalReturns || 0,
//       icon: (
//         <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
//         </svg>
//       ),
//       color: 'bg-blue-50'
//     },
//     {
//       title: 'Pending Returns',
//       value: stats?.pendingReturns || 0,
//       icon: (
//         <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//         </svg>
//       ),
//       color: 'bg-yellow-50'
//     },
//     {
//       title: 'Approved Returns',
//       value: stats?.approvedReturns || 0,
//       icon: (
//         <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//         </svg>
//       ),
//       color: 'bg-green-50'
//     },
//     {
//       title: 'Total Refunds',
//       value: formatCurrency(stats?.totalRefundAmount || 0),
//       icon: (
//         <svg className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//         </svg>
//       ),
//       color: 'bg-purple-50'
//     }
//   ];

//   return (
//     <DashboardLayout>
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Header */}
//         <div className="py-4 border-b border-gray-200">
//           <div className="flex justify-between items-center">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900">Return Policy</h1>
//               <p className="mt-1 text-sm text-gray-600">
//                 Manage product returns and refund requests
//               </p>
//             </div>
//             <button
//               onClick={() => setShowCreateModal(true)}
//               className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700"
//             >
//               <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//               </svg>
//               Create Return Request
//             </button>
//           </div>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mt-6">
//           {statsCards.map((card, index) => (
//             <div key={index} className={`${card.color} overflow-hidden shadow rounded-lg`}>
//               <div className="p-5">
//                 <div className="flex items-center">
//                   <div className="flex-shrink-0">
//                     {card.icon}
//                   </div>
//                   <div className="ml-5 w-0 flex-1">
//                     <dl>
//                       <dt className="text-sm font-medium text-gray-500 truncate">
//                         {card.title}
//                       </dt>
//                       <dd className="text-lg font-medium text-gray-900">
//                         {card.value}
//                       </dd>
//                     </dl>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Filters */}
//         <div className="mt-6 bg-white shadow rounded-lg">
//           <div className="px-4 py-5 sm:p-6">
//             <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
//               {/* Search */}
//               <div className="sm:col-span-2">
//                 <label className="block text-sm font-medium text-gray-700">Search</label>
//                 <div className="mt-1 relative rounded-md shadow-sm">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                     </svg>
//                   </div>
//                   <input
//                     type="text"
//                     value={filters.searchTerm}
//                     onChange={(e) => setFilters(prev => ({ ...prev, searchTerm: e.target.value }))}
//                     className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
//                     placeholder="Search by return ID, customer, invoice..."
//                   />
//                 </div>
//               </div>

//               {/* Status Filter */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700">Status</label>
//                 <select
//                   value={filters.status}
//                   onChange={(e) => setFilters(prev => ({ ...prev, status: e.target.value }))}
//                   className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
//                 >
//                   <option value="all">All Status</option>
//                   <option value="pending">Pending</option>
//                   <option value="approved">Approved</option>
//                   <option value="rejected">Rejected</option>
//                   <option value="processing">Processing</option>
//                   <option value="completed">Completed</option>
//                 </select>
//               </div>

//               {/* Sort */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700">Sort By</label>
//                 <select
//                   value={`${filters.sortBy}-${filters.sortOrder}`}
//                   onChange={(e) => {
//                     const [sortBy, sortOrder] = e.target.value.split('-');
//                     setFilters(prev => ({ ...prev, sortBy, sortOrder }));
//                   }}
//                   className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
//                 >
//                   <option value="createdAt-desc">Newest First</option>
//                   <option value="createdAt-asc">Oldest First</option>
//                   <option value="totalRefundAmount-desc">Highest Refund</option>
//                   <option value="totalRefundAmount-asc">Lowest Refund</option>
//                 </select>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Returns Table */}
//         <div className="mt-6 bg-white shadow overflow-hidden sm:rounded-md">
//           <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
//             <h3 className="text-lg leading-6 font-medium text-gray-900">
//               Return Requests ({returns.length})
//             </h3>
//           </div>

//           {loading ? (
//             <div className="flex justify-center items-center h-64">
//               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
//             </div>
//           ) : returns.length === 0 ? (
//             <div className="text-center py-12">
//               <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
//               </svg>
//               <h3 className="mt-2 text-sm font-medium text-gray-900">No return requests</h3>
//               <p className="mt-1 text-sm text-gray-500">
//                 Get started by creating your first return request.
//               </p>
//               <div className="mt-6">
//                 <button
//                   onClick={() => setShowCreateModal(true)}
//                   className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700"
//                 >
//                   <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//                   </svg>
//                   Create Return Request
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <>
//               <ul className="divide-y divide-gray-200">
//                 {returns.map((returnRequest) => (
//                   <li key={returnRequest.id} className="px-4 py-4 sm:px-6">
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center">
//                         <div className="flex-shrink-0">
//                           <div className="h-10 w-10 rounded-full bg-orange-100 flex items-center justify-center">
//                             <svg className="h-6 w-6 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
//                             </svg>
//                           </div>
//                         </div>
//                         <div className="ml-4">
//                           <div className="flex items-center">
//                             <p className="text-sm font-medium text-gray-900">
//                               {returnRequest.returnId}
//                             </p>
//                             <div className="ml-2">
//                               {getStatusBadge(returnRequest.status)}
//                             </div>
//                           </div>
//                           <div className="mt-1 flex items-center text-sm text-gray-500">
//                             <p>
//                               Customer: {returnRequest.customerName}
//                             </p>
//                             <span className="mx-2">•</span>
//                             <p>
//                               Invoice: {returnRequest.invoiceNumber}
//                             </p>
//                             <span className="mx-2">•</span>
//                             <p>
//                               {formatDate(returnRequest.createdAt)}
//                             </p>
//                           </div>
//                           <div className="mt-1 text-sm text-gray-500">
//                             <p>
//                               Items: {returnRequest.items?.length || 0} • 
//                               Refund: {formatCurrency(returnRequest.totalRefundAmount)}
//                             </p>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="flex items-center space-x-2">
//                         {returnRequest.status === 'pending' && (
//                           <>
//                             <button
//                               onClick={() => handleStatusUpdate(returnRequest.id, 'approved', '')}
//                               disabled={actionLoading === `status-${returnRequest.id}`}
//                               className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-full text-white bg-green-600 hover:bg-green-700 disabled:opacity-50"
//                             >
//                               Approve
//                             </button>
//                             <button
//                               onClick={() => handleStatusUpdate(returnRequest.id, 'rejected', '')}
//                               disabled={actionLoading === `status-${returnRequest.id}`}
//                               className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-full text-white bg-red-600 hover:bg-red-700 disabled:opacity-50"
//                             >
//                               Reject
//                             </button>
//                           </>
//                         )}

//                         <button
//                           onClick={() => handleViewDetails(returnRequest)}
//                           className="inline-flex items-center px-3 py-1 border border-gray-300 text-xs font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
//                         >
//                           View Details
//                         </button>

//                         <button
//                           onClick={() => handleDeleteReturn(returnRequest.id)}
//                           disabled={actionLoading === `delete-${returnRequest.id}`}
//                           className="text-red-600 hover:text-red-900 disabled:opacity-50"
//                         >
//                           <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                           </svg>
//                         </button>
//                       </div>
//                     </div>
//                   </li>
//                 ))}
//               </ul>

//               {/* Load More */}
//               {pagination.hasMore && (
//                 <div className="px-4 py-3 border-t border-gray-200 sm:px-6">
//                   <button
//                     onClick={() => loadReturns(true)}
//                     disabled={loading}
//                     className="w-full inline-flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//                   >
//                     {loading ? 'Loading...' : 'Load More'}
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         {/* Modals */}
//         {showCreateModal && (
//           <CreateReturnModal
//             onClose={() => setShowCreateModal(false)}
//             onSuccess={() => {
//               setShowCreateModal(false);
//               loadReturns();
//               loadStats();
//             }}
//           />
//         )}

//         {showDetailsModal && selectedReturn && (
//           <ReturnDetailsModal
//             returnRequest={selectedReturn}
//             onClose={() => {
//               setShowDetailsModal(false);
//               setSelectedReturn(null);
//             }}
//             onStatusUpdate={(returnId, status, notes) => {
//               handleStatusUpdate(returnId, status, notes);
//               setShowDetailsModal(false);
//               setSelectedReturn(null);
//             }}
//           />
//         )}
//       </div>
//     </DashboardLayout>
//   );
// };

// export default ReturnsPage;


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { 
  getInvoicesForReturns, 
  createReturnRequest,
  deleteReturnRequest,
  getReturnStatistics,
  getReturnRequests
} from '../../services/returnsService';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';

const ReturnsPage = () => {
  const { currentUser } = useAuth();
  const { showAlert } = useNotification();
  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [returns, setReturns] = useState([]);
  const [filteredReturns, setFilteredReturns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [actionLoading, setActionLoading] = useState('');
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [viewMode, setViewMode] = useState('invoices'); // 'invoices' or 'returns'
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilter, setDateFilter] = useState('all'); // 'all', 'today', 'last7days', 'last30days', 'lastyear'

  // Date filter options
  const dateFilterOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'lastyear', label: 'Last Year' }
  ];

  useEffect(() => {
    if (viewMode === 'invoices') {
      loadInvoices();
    } else {
      loadReturns();
    }
    loadStats();
  }, [currentUser, viewMode]);

  // Filter invoices based on search term and date filter
  useEffect(() => {
    let filtered = invoices;

    // Apply search filter
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(invoice => {
        return (
          invoice.invoiceNumber?.toLowerCase().includes(term) ||
          invoice.customerName?.toLowerCase().includes(term) ||
          invoice.customerPhone?.toLowerCase().includes(term) ||
          invoice.customerEmail?.toLowerCase().includes(term)
        );
      });
    }

    // Apply date filter
    if (dateFilter !== 'all') {
      filtered = filtered.filter(invoice => {
        const invoiceDate = invoice.createdAt ? new Date(invoice.createdAt) : null;
        if (!invoiceDate) return false;

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
        switch (dateFilter) {
          case 'today':
            return invoiceDate >= today;
          case 'last7days':
            const last7Days = new Date(today);
            last7Days.setDate(today.getDate() - 7);
            return invoiceDate >= last7Days;
          case 'last30days':
            const last30Days = new Date(today);
            last30Days.setDate(today.getDate() - 30);
            return invoiceDate >= last30Days;
          case 'lastyear':
            const lastYear = new Date(today);
            lastYear.setFullYear(today.getFullYear() - 1);
            return invoiceDate >= lastYear;
          default:
            return true;
        }
      });
    }

    setFilteredInvoices(filtered);
  }, [invoices, searchTerm, dateFilter]);

  // Filter returns based on date filter
  useEffect(() => {
    let filtered = returns;

    // Apply date filter
    if (dateFilter !== 'all') {
      filtered = filtered.filter(returnReq => {
        const returnDate = returnReq.createdAt ? new Date(returnReq.createdAt) : null;
        if (!returnDate) return false;

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
        switch (dateFilter) {
          case 'today':
            return returnDate >= today;
          case 'last7days':
            const last7Days = new Date(today);
            last7Days.setDate(today.getDate() - 7);
            return returnDate >= last7Days;
          case 'last30days':
            const last30Days = new Date(today);
            last30Days.setDate(today.getDate() - 30);
            return returnDate >= last30Days;
          case 'lastyear':
            const lastYear = new Date(today);
            lastYear.setFullYear(today.getFullYear() - 1);
            return returnDate >= lastYear;
          default:
            return true;
        }
      });
    }

    setFilteredReturns(filtered);
  }, [returns, dateFilter]);

  const loadInvoices = async () => {
    try {
      setLoading(true);
      const invoiceList = await getInvoicesForReturns({});
      setInvoices(invoiceList);
    } catch (error) {
      console.error('Error loading invoices:', error);
      showAlert('Failed to load invoices', 'error');
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  const loadReturns = async () => {
    try {
      setLoading(true);
      const { returns } = await getReturnRequests({});
      setReturns(returns);
    } catch (error) {
      console.error('Error loading returns:', error);
      showAlert('Failed to load return history', 'error');
      setReturns([]);
    } finally {
      setLoading(false);
    }
  };

  const loadStats = async () => {
    try {
      const statistics = await getReturnStatistics();
      setStats(statistics);
    } catch (error) {
      console.error('Error loading return statistics:', error);
      showAlert('Failed to load statistics', 'error');
      setStats({
        totalReturns: 0,
        totalRefundAmount: 0
      });
    }
  };

  const handleReturnAll = async (invoice) => {
    if (!window.confirm(`Are you sure you want to return all items in invoice ${invoice.invoiceNumber}?`)) {
      return;
    }

    try {
      setActionLoading(`return-all-${invoice.id}`);
      const returnData = {
        invoiceId: invoice.id,
        invoiceNumber: invoice.invoiceNumber,
        customerName: invoice.customerName,
        customerEmail: invoice.customerEmail,
        customerPhone: invoice.customerPhone,
        items: invoice.items.map(item => ({
          ...item,
          returnQuantity: item.quantity,
          returnReason: 'return_all',
          unitPrice: item.rate || item.price || 0,
          maxQuantity: item.quantity
        })),
        reason: 'return_all',
        customerRequest: true,
        refundMethod: 'original'
      };

      await createReturnRequest(returnData);
      await deleteDoc(doc(db, 'invoices', invoice.id));
      setInvoices(prev => prev.filter(inv => inv.id !== invoice.id));
      showAlert('Return request created and invoice deleted successfully', 'success');
      await loadStats();
      if (viewMode === 'returns') {
        await loadReturns();
      }
    } catch (error) {
      console.error('Error processing return all:', error);
      showAlert('Failed to process return request', 'error');
    } finally {
      setActionLoading('');
    }
  };

  const handleReturnSelected = async (invoice) => {
    if (selectedItems.length === 0) {
      showAlert('Please select at least one item to return', 'error');
      return;
    }

    const invalidItems = selectedItems.filter(item => item.returnQuantity <= 0 || item.returnQuantity > item.maxQuantity);
    if (invalidItems.length > 0) {
      showAlert('Invalid quantity selected for one or more items', 'error');
      return;
    }

    if (!window.confirm(`Are you sure you want to return ${selectedItems.length} item(s) from invoice ${invoice.invoiceNumber}?`)) {
      return;
    }

    try {
      setActionLoading(`return-selected-${invoice.id}`);
      const returnData = {
        invoiceId: invoice.id,
        invoiceNumber: invoice.invoiceNumber,
        customerName: invoice.customerName,
        customerEmail: invoice.customerEmail,
        customerPhone: invoice.customerPhone,
        items: selectedItems.map(item => ({
          ...item,
          returnQuantity: item.returnQuantity,
          returnReason: 'return_selected',
          unitPrice: item.rate || item.price || 0,
          maxQuantity: item.quantity
        })),
        reason: 'return_selected',
        customerRequest: true,
        refundMethod: 'original'
      };

      await createReturnRequest(returnData);
      
      const updatedItems = invoice.items.map(item => {
        const selectedItem = selectedItems.find(selected => selected.productId === item.productId);
        if (selectedItem) {
          const newQuantity = item.quantity - selectedItem.returnQuantity;
          return newQuantity > 0 ? { ...item, quantity: newQuantity } : null;
        }
        return item;
      }).filter(item => item !== null);

      if (updatedItems.length === 0) {
        await deleteDoc(doc(db, 'invoices', invoice.id));
        setInvoices(prev => prev.filter(inv => inv.id !== invoice.id));
      } else {
        const invoiceRef = doc(db, 'invoices', invoice.id);
        await updateDoc(invoiceRef, {
          items: updatedItems,
          totalAmount: updatedItems.reduce((sum, item) => sum + (item.quantity * (item.rate || item.price || 0)), 0),
          updatedAt: new Date()
        });
        setInvoices(prev => prev.map(inv => 
          inv.id === invoice.id ? { ...inv, items: updatedItems } : inv
        ));
      }

      showAlert('Return request for selected items created successfully', 'success');
      setSelectedInvoiceId(null);
      setSelectedItems([]);
      await loadStats();
      if (viewMode === 'returns') {
        await loadReturns();
      }
    } catch (error) {
      console.error('Error processing return selected:', error);
      showAlert('Failed to process return request', 'error');
    } finally {
      setActionLoading('');
    }
  };

  const toggleItemSelection = (item) => {
    setSelectedItems(prev => {
      if (prev.some(selected => selected.productId === item.productId)) {
        return prev.filter(selected => selected.productId !== item.productId);
      }
      return [...prev, { ...item, returnQuantity: 1, maxQuantity: item.quantity }];
    });
  };

  const updateItemQuantity = (productId, quantity) => {
    setSelectedItems(prev => prev.map(item => 
      item.productId === productId 
        ? { ...item, returnQuantity: Math.min(Math.max(1, parseInt(quantity) || 1), item.maxQuantity) }
        : item
    ));
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(amount);
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getFilteredCount = () => {
    if (viewMode === 'invoices') {
      return filteredInvoices.length;
    } else {
      return filteredReturns.length;
    }
  };

  const getTotalCount = () => {
    if (viewMode === 'invoices') {
      return invoices.length;
    } else {
      return returns.length;
    }
  };

  const statsCards = [
    {
      title: 'Total Returns',
      value: stats?.totalReturns || 0,
      icon: (
        <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
        </svg>
      ),
      color: 'bg-blue-50'
    },
    {
      title: 'Total Refunds',
      value: formatCurrency(stats?.totalRefundAmount || 0),
      icon: (
        <svg className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: 'bg-purple-50'
    }
  ];

  const currentData = viewMode === 'invoices' ? filteredInvoices : filteredReturns;

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="py-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Returns</h1>
              <p className="mt-1 text-sm text-gray-600">
                Manage product returns and view return history
              </p>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2 mt-6">
          {statsCards.map((card, index) => (
            <div key={index} className={`${card.color} overflow-hidden shadow rounded-lg`}>
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    {card.icon}
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">
                        {card.title}
                      </dt>
                      <dd className="text-lg font-medium text-gray-900">
                        {card.value}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Toggle Buttons */}
        <div className="mt-4 flex justify-start space-x-4">
          <button
            onClick={() => setViewMode('invoices')}
            className={`px-4 py-2 text-sm font-medium rounded-md ${
              viewMode === 'invoices'
                ? 'bg-red-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Invoices
          </button>
          <button
            onClick={() => setViewMode('returns')}
            className={`px-4 py-2 text-sm font-medium rounded-md ${
              viewMode === 'returns'
                ? 'bg-red-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Return History
          </button>
        </div>

        {/* Filters Section */}
        <div className="mt-4 bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {/* Search Bar - Only show for invoices view */}
              {viewMode === 'invoices' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Search Invoices
                  </label>
                  <div className="relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-red-500 focus:border-red-500 sm:text-sm"
                      placeholder="Search by invoice number, customer name, phone number..."
                    />
                  </div>
                </div>
              )}

              {/* Date Filter */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Filter by Date
                </label>
                <select
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md leading-5 bg-white focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500 sm:text-sm"
                >
                  {dateFilterOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Filter Results Summary */}
            <div className="mt-4 text-sm text-gray-500">
              {dateFilter !== 'all' || (viewMode === 'invoices' && searchTerm) ? (
                <p>
                  Showing {getFilteredCount()} of {getTotalCount()} {viewMode === 'invoices' ? 'invoices' : 'returns'}
                  {dateFilter !== 'all' && (
                    <span> • Filtered by: {dateFilterOptions.find(opt => opt.value === dateFilter)?.label}</span>
                  )}
                  {viewMode === 'invoices' && searchTerm && (
                    <span> • Search: "{searchTerm}"</span>
                  )}
                </p>
              ) : (
                <p>Showing all {getTotalCount()} {viewMode === 'invoices' ? 'invoices' : 'returns'}</p>
              )}
            </div>

            {/* Clear Filters */}
            {(dateFilter !== 'all' || (viewMode === 'invoices' && searchTerm)) && (
              <div className="mt-4">
                <button
                  onClick={() => {
                    setDateFilter('all');
                    setSearchTerm('');
                  }}
                  className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Clear All Filters
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="mt-6 bg-white shadow overflow-hidden sm:rounded-md">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {viewMode === 'invoices' 
                ? `Invoices (${getFilteredCount()})` 
                : `Return History (${getFilteredCount()})`
              }
            </h3>
          </div>

          {loading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
            </div>
          ) : currentData.length === 0 ? (
            <div className="text-center py-12">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900">
                {dateFilter !== 'all' || (viewMode === 'invoices' && searchTerm) ? 'No matching records found' : `No ${viewMode === 'invoices' ? 'invoices' : 'returns'} available`}
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                {dateFilter !== 'all' || (viewMode === 'invoices' && searchTerm) 
                  ? 'Try adjusting your filters to see more results.'
                  : `No ${viewMode === 'invoices' ? 'eligible invoices found for returns' : 'return requests found'}.`
                }
              </p>
            </div>
          ) : viewMode === 'invoices' ? (
            <ul className="divide-y divide-gray-200">
              {filteredInvoices.map((invoice) => (
                <li key={invoice.id} className="px-4 py-4 sm:px-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex-shrink-0">
                        <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center">
                          <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <p className="text-sm font-medium text-gray-900">
                          {invoice.invoiceNumber}
                        </p>
                        <div className="mt-1 flex items-center text-sm text-gray-500">
                          <p>Customer: {invoice.customerName}</p>
                          <span className="mx-2">•</span>
                          <p>Phone: {invoice.customerPhone}</p>
                          <span className="mx-2">•</span>
                          <p>Date: {formatDate(invoice.createdAt)}</p>
                        </div>
                        <div className="mt-1 text-sm text-gray-500">
                          <p>Items: {invoice.items?.length || 0} • Total: {formatCurrency(invoice.totalAmount)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => handleReturnAll(invoice)}
                        disabled={actionLoading === `return-all-${invoice.id}`}
                        className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-full text-white bg-red-600 hover:bg-red-700 disabled:opacity-50"
                      >
                        Return All
                      </button>
                      <button
                        onClick={() => setSelectedInvoiceId(invoice.id === selectedInvoiceId ? null : invoice.id)}
                        className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
                      >
                        {selectedInvoiceId === invoice.id ? 'Cancel' : 'Return Selected'}
                      </button>
                    </div>
                  </div>
                  <div className="mt-4 ml-14">
                    <h4 className="text-sm font-medium text-gray-700">Items:</h4>
                    <ul className="mt-2 space-y-2">
                      {invoice.items.map((item, index) => (
                        <li key={index} className="text-sm text-gray-600">
                          <span>{item.name}</span>
                          <span className="mx-2">•</span>
                          <span>Quantity: {item.quantity}</span>
                          <span className="mx-2">•</span>
                          <span>Price: {formatCurrency(item.rate || item.price)}</span>
                          <span className="mx-2">•</span>
                          <span>Product ID: {item.productId}</span>
                        </li>
                      ))}
                    </ul>
                    {selectedInvoiceId === invoice.id && (
                      <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                        <h4 className="text-sm font-medium text-gray-900 mb-2">Select Items to Return</h4>
                        <ul className="space-y-4">
                          {invoice.items.map((item, index) => (
                            <li key={index} className="flex items-center space-x-4">
                              <input
                                type="checkbox"
                                checked={selectedItems.some(selected => selected.productId === item.productId)}
                                onChange={() => toggleItemSelection(item)}
                                className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                              />
                              <span className="flex-1 text-sm text-gray-600">{item.name}</span>
                              {selectedItems.some(selected => selected.productId === item.productId) && (
                                <div className="flex items-center space-x-2">
                                  <label className="text-sm text-gray-600">Quantity:</label>
                                  <input
                                    type="number"
                                    min="1"
                                    max={item.quantity}
                                    value={selectedItems.find(selected => selected.productId === item.productId)?.returnQuantity || 1}
                                    onChange={(e) => updateItemQuantity(item.productId, e.target.value)}
                                    className="w-20 px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                                  />
                                  <span className="text-sm text-gray-600">/ {item.quantity}</span>
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                        <div className="mt-4 flex justify-end space-x-2">
                          <button
                            onClick={() => {
                              setSelectedInvoiceId(null);
                              setSelectedItems([]);
                            }}
                            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => handleReturnSelected(invoice)}
                            disabled={actionLoading === `return-selected-${invoice.id}` || selectedItems.length === 0}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 disabled:opacity-50"
                          >
                            {actionLoading === `return-selected-${invoice.id}` ? 'Processing...' : 'Confirm Return'}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <ul className="divide-y divide-gray-200">
              {filteredReturns.map((returnReq) => (
                <li key={returnReq.id} className="px-4 py-4 sm:px-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex-shrink-0">
                        <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center">
                          <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <p className="text-sm font-medium text-gray-900">
                          {returnReq.returnId}
                        </p>
                        <div className="mt-1 flex items-center text-sm text-gray-500">
                          <p>Invoice: {returnReq.invoiceNumber}</p>
                          <span className="mx-2">•</span>
                          <p>Customer: {returnReq.customerName}</p>
                          <span className="mx-2">•</span>
                          <p>Status: {returnReq.status.charAt(0).toUpperCase() + returnReq.status.slice(1)}</p>
                        </div>
                        <div className="mt-1 text-sm text-gray-500">
                          <p>Date: {formatDate(returnReq.createdAt)}</p>
                          <span className="mx-2">•</span>
                          <p>Total: {formatCurrency(returnReq.totalRefundAmount)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 ml-14">
                    <h4 className="text-sm font-medium text-gray-700">Items:</h4>
                    <ul className="mt-2 space-y-2">
                      {returnReq.items.map((item, index) => (
                        <li key={index} className="text-sm text-gray-600">
                          <span>{item.name}</span>
                          <span className="mx-2">•</span>
                          <span>Return Quantity: {item.returnQuantity}</span>
                          <span className="mx-2">•</span>
                          <span>Price: {formatCurrency(item.unitPrice)}</span>
                          <span className="mx-2">•</span>
                          <span>Product ID: {item.productId}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ReturnsPage;